export default {
  getClass: { // 查询标准分类
    method: 'get',
    url: '/standard_classification'
  },
  postClass: { // 新增标准分类
    method: 'post',
    url: '/standard_classification'
  },
  putClass: { // 修改标准分类
    method: 'put',
    url: '/standard_classification'
  },
  putSort: { // 修改标准分类
    method: 'put',
    url: '/standard_classification/sort'
  },
  deleteClass: { // 删除标准分类
    method: 'delete',
    url: '/standard_classification'
  },
  getStandard: { // 查询标准文件
    method: 'get',
    url: '/standard'
  },
  postStandard: { // 新增标准文件
    method: 'post',
    url: '/standard'
  },
  putStandard: { // 修改标准文件
    method: 'put',
    url: '/standard'
  },
  deleteStandard: { // 删除标准文件
    method: 'delete',
    url: '/standard'
  }
}
